export class SmartcardNotFoundError extends Error {
  constructor() {
    super("Smart card number supplied did not return any customer.");
    this.name = "SmartcardNotFoundError";
  }
}
